import React from 'react';

export const FieldArrayRenderer = (props: any & { fieldComponent: React.ComponentType<any> }) => {
  const { fields, fieldComponent: FieldComponent, ...rest } = props;

  return fields.map((field: string, index: number) => (
    <FieldComponent name={field} key={field} {...rest} index={index} />
  ));
};
